import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["callback", "href", "target", "title"],
  _excluded2 = ["id"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import LinkComponent from '../../../typography/Link';
var validLinkAttributes = ['id', 'title'];
var Link = function Link(_ref) {
  var callback = _ref.callback,
    href = _ref.href,
    target = _ref.target,
    title = _ref.title,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    finalTitle = _useState2[0],
    setFinalTitle = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    attributes = _useState4[0],
    setAttributes = _useState4[1];
  var handleClick = useCallback(function (event) {
    if (callback) {
      event.preventDefault();
      var link = function link() {
        var finalTarget = target || (attributes === null || attributes === void 0 ? void 0 : attributes.target);
        if (!finalTarget || finalTarget === '_self') {
          window.location.href = href;
        } else {
          window.open(href, finalTarget);
        }
      };
      callback({
        event: event,
        attributes: attributes,
        link: link
      });
    }
  }, [attributes, callback, href, target]);
  var parseTitleString = useCallback(function (str) {
    try {
      var parsedJson = JSON.parse(str);
      var finalAttributes = Object.entries(parsedJson).reduce(function (acc, _ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          key = _ref3[0],
          value = _ref3[1];
        if (validLinkAttributes.includes(key)) {
          acc[key] = value;
        }
        return acc;
      }, {});
      setAttributes(finalAttributes);
    } catch (error) {
      setFinalTitle(str);
    }
  }, []);
  useEffect(function () {
    title && parseTitleString(title);
  }, [parseTitleString, title]);
  var linkProps = useMemo(function () {
    var id = attributes.id,
      otherAttrs = _objectWithoutProperties(attributes, _excluded2);
    return _objectSpread(_objectSpread({
      href: href,
      target: target,
      title: finalTitle,
      onClick: handleClick
    }, otherAttrs), otherProps);
  }, [attributes, finalTitle, handleClick, href, otherProps, target]);
  return /*#__PURE__*/React.createElement(LinkComponent, linkProps);
};
export default /*#__PURE__*/memo(Link);